module.exports = __webpack_public_path__ + "static/img/3-1.b2f68142.png";